module.exports = __webpack_public_path__ + "images/ExternalPromo/lyrics-728-2.png?f7d5a";